module.exports = __webpack_public_path__ + "img/comment-svg.c94efbc5.svg";